import { Grid } from "@material-ui/core";
import { useFormik } from "formik";
import { useEffect } from "react";
import RxMaskedTextField from "../../../components/RxMaskedTextField";
import RxSelectBox from "../../../components/RxSelectBox";
import { RxSelectBoxItemObject } from "../../../components/RxSelectBox/RxSelectBox";
import RxTypography from "../../../components/RxTypography";
import { RxPaymentObject, RxPaymentObjectInıtialValue } from "../PaymentObject";
import { PaymentStepFormValidationObject } from "../PaymentPage";
import styles from "./PaymentStep.module.css";
import PaymentStepValidation from "./PaymentStepValidation";

interface PaymentStepProps {
	setValidataResult?: any;
	values: RxPaymentObject;
}

const PaymentStep = (props: PaymentStepProps) => {
	const paymentURL = import.meta.env.VITE_SANAL_POS_URL;
	const formik = useFormik({
		initialValues: {
			...props.values,
			Ecom_Payment_Card_ExpDate_Year:
				RxPaymentObjectInıtialValue.Ecom_Payment_Card_ExpDate_Year,
			Ecom_Payment_Card_ExpDate_Month:
				RxPaymentObjectInıtialValue.Ecom_Payment_Card_ExpDate_Month,
			cardType: RxPaymentObjectInıtialValue.cardType,
			instalment: RxPaymentObjectInıtialValue.instalment,
		},
		validationSchema: PaymentStepValidation,
		validateOnBlur: true,
		validateOnChange: true,
		onSubmit: () => {
			// Form submit edilmediği için bulunuyor. (Sonar uyarısı için)
			console.log("No submit button for this form...");
		},
	});

	useEffect(() => {
		if (!formik.isValid) {
			props.setValidataResult &&
				props.setValidataResult(
					(
						prev: PaymentStepFormValidationObject
					): PaymentStepFormValidationObject => {
						return {
							...prev,
							isPayStepValid: false,
						};
					}
				);
		} else {
			props.setValidataResult &&
				props.setValidataResult(
					(
						prev: PaymentStepFormValidationObject
					): PaymentStepFormValidationObject => {
						return {
							...prev,
							isPayStepValid: true,
						};
					}
				);
		}
	}, [formik.isValid]); // eslint-disable-line

	useEffect(() => {
		props.setValidataResult &&
			props.setValidataResult(
				(
					prev: PaymentStepFormValidationObject
				): PaymentStepFormValidationObject => {
					return {
						...prev,
						values: {
							...formik.values,
						},
					};
				}
			);
	}, [formik.values]); // eslint-disable-line

	useEffect(() => {
		formik.validateForm();
	}, []); // eslint-disable-line

	return (
		<form method="post" action={paymentURL}>
			<Grid container direction="row" spacing={5}>
				<Grid item xs={12} sm={12}>
					<Grid container spacing={1}>
						<Grid item xs={1} sm={1} md={1}></Grid>
						<Grid item xs={2} sm={2}>
							<img
								src="https://sanalpos.isbank.com.tr/fim/est3dimages/isbank/visa.gif"
								width="100"
								height="55"
								alt="Visa"
							/>
						</Grid>
						<Grid item xs={6} sm={6}></Grid>
						<Grid item xs={2} sm={2}>
							<img
								src="https://sanalpos.isbank.com.tr/fim/est3dimages/isbank/mastercard.gif"
								width="100"
								height="55"
								alt="MasterCard"
							/>
						</Grid>
						<Grid item xs={1} sm={1}></Grid>
					</Grid>
					<Grid
						container
						spacing={1}
						className={styles.marginVerticalFourty}
					>
						<Grid container spacing={1}>
							<Grid item xs={12} sm={12} md={12}>
								<Grid
									container
									spacing={1}
									justifyContent="center"
									alignItems="center"
								>
									<Grid item xs={12} sm={2} md={2}></Grid>
									<Grid item xs={12} sm={3} md={3}>
										<RxTypography
											variant="body1"
											align="left"
											label="Kredi Kartı Numarası"
											className={styles.verticleAlignMiddle}
										/>
									</Grid>
									<Grid item xs={12} sm={4} md={4}>
										<RxMaskedTextField
											fullwidth
											variant="outlined"
											size="small"
											id="pan"
											name="pan"
											mask="9999-9999-9999-9999"
											value={formik.values.pan}
											onChange={formik.handleChange}
											onBlur={formik.handleBlur}
											required
										/>
									</Grid>
									<Grid item xs={3} sm={2} md={3}></Grid>
								</Grid>
								<Grid
									container
									spacing={1}
									alignItems="center"
									justifyContent="center"
								>
									<Grid item xs={3} sm={2} md={2}></Grid>
									<Grid item xs={12} sm={3} md={3}>
										<RxTypography
											variant="body1"
											align="left"
											label="Son Kullanma Tarihi"
											className={styles.verticleAlignMiddle}
										/>
									</Grid>
									<Grid item xs={6} sm={2} md={2}>
										<RxSelectBox
											fullwidth
											variant="outlined"
											size="small"
											items={Array.from(Array(12).keys()).map(
												(item) => {
													const monthValue = item + 1;
													return {
														label: monthValue,
														value: monthValue,
													} as RxSelectBoxItemObject;
												}
											)}
											id="Ecom_Payment_Card_ExpDate_Month"
											name="Ecom_Payment_Card_ExpDate_Month"
											value={
												formik.values
													.Ecom_Payment_Card_ExpDate_Month
											}
											onChange={formik.handleChange}
											onBlur={formik.handleBlur}
										/>
									</Grid>
									<Grid item xs={6} sm={2} md={2}>
										<RxSelectBox
											fullwidth
											variant="outlined"
											size="small"
											items={Array.from(Array(15).keys()).map(
												(item) => {
													const yearValue =
														parseInt(
															new Date()
																.getFullYear()
																.toString()
																.slice(2),
															10
														) + item;
													return {
														label: yearValue,
														value: yearValue,
													} as RxSelectBoxItemObject;
												}
											)}
											id="Ecom_Payment_Card_ExpDate_Year"
											name="Ecom_Payment_Card_ExpDate_Year"
											value={
												formik.values.Ecom_Payment_Card_ExpDate_Year
											}
											onChange={formik.handleChange}
											onBlur={formik.handleBlur}
										/>
									</Grid>
									<Grid item xs={4} sm={2} md={3}></Grid>
								</Grid>
								<Grid
									container
									spacing={1}
									justifyContent="center"
									alignItems="center"
								>
									<Grid item xs={3} sm={2} md={2}></Grid>
									<Grid item xs={12} sm={3} md={3}>
										<RxTypography
											variant="body1"
											align="left"
											label="Güvenlik Kodu"
											className={styles.verticleAlignMiddle}
										/>
									</Grid>
									<Grid item xs={6} sm={2} md={2}>
										<RxMaskedTextField
											fullwidth
											variant="outlined"
											size="small"
											id="cv2"
											name="cv2"
											mask="999"
											value={formik.values.cv2}
											onChange={formik.handleChange}
											onBlur={formik.handleBlur}
											required
										/>
									</Grid>
									<Grid item xs={6} sm={4} md={5}>
										<RxTypography
											variant="body1"
											align="left"
											label="(Kredi kartı arkasında yer alan 3 haneli sayı)"
											color="error"
											className={styles.verticleAlignMiddle}
										/>
									</Grid>
								</Grid>
								<Grid
									container
									spacing={1}
									justifyContent="center"
									alignItems="center"
								>
									<Grid item xs={3} sm={2} md={2}></Grid>
									<Grid item xs={12} sm={3} md={3}>
										<RxTypography
											variant="body1"
											align="left"
											label="Visa / MasterCard Seçimi"
											className={styles.verticleAlignMiddle}
										/>
									</Grid>
									<Grid item xs={12} sm={4} md={4}>
										<RxSelectBox
											fullwidth
											variant="outlined"
											size="small"
											items={[
												{
													label: "Visa",
													value: "1",
												} as RxSelectBoxItemObject,
												{
													label: "MasterCard",
													value: "2",
												} as RxSelectBoxItemObject,
											]}
											id="cardType"
											name="cardType"
											value={formik.values.cardType}
											onChange={formik.handleChange}
											onBlur={formik.handleBlur}
										/>
									</Grid>
									<Grid item xs={3} sm={2} md={3}></Grid>
								</Grid>
								<Grid
									container
									spacing={1}
									justifyContent="center"
									alignItems="center"
								>
									<Grid item xs={3} sm={2} md={2}></Grid>
									<Grid item xs={12} sm={3} md={3}>
										<RxTypography
											variant="body1"
											align="left"
											label="Taksit"
											className={styles.verticleAlignMiddle}
										/>
									</Grid>
									<Grid item xs={12} sm={4} md={4}>
										<RxSelectBox
											fullwidth
											variant="outlined"
											size="small"
											items={Array.from(
												Array(props.values.maxInstallment).keys()
											).map((item) => {
												const tmpItem = ++item;
												return {
													label:
														tmpItem === 1
															? "Peşin"
															: tmpItem.toString(),
													value: tmpItem.toString(),
												} as RxSelectBoxItemObject;
											})}
											id="instalment"
											name="instalment"
											value={formik.values.instalment}
											onChange={formik.handleChange}
											onBlur={formik.handleBlur}
										/>
									</Grid>
									<Grid item xs={3} sm={2} md={3}></Grid>
								</Grid>
								<Grid
									container
									spacing={1}
									justifyContent="center"
									alignItems="center"
								>
									<Grid item xs={3} sm={2} md={2}></Grid>
									<Grid item xs={12} sm={3} md={3}>
										<RxTypography
											variant="body1"
											align="left"
											label="Ödenecek Tutar"
											className={styles.verticleAlignMiddle}
										/>
									</Grid>
									<Grid item xs={12} sm={4} md={4}>
										<RxTypography
											variant="body1"
											align="left"
											label={
												formik.values.saleDetail.totalPriceWithKdv.toFixed(
													2
												) + " TL"
											}
											className={styles.verticleAlignMiddleAndBold}
											color="error"
										/>
									</Grid>
									<Grid item xs={3} sm={2} md={3}></Grid>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
					<Grid container spacing={1}>
						<Grid item xs={1} sm={1}></Grid>
						<Grid item xs={2} sm={2}>
							<img
								src="https://sanalpos.isbank.com.tr/fim/est3dimages/isbank/visa_electron.gif"
								width="100"
								height="55"
								alt="VisaElectron"
							/>
						</Grid>
						<Grid item xs={6} sm={6}>
							<img
								src="https://sanalpos.isbank.com.tr/fim/est3dimages/isbank/maximumlogo.jpg"
								width="210"
								height="55"
								alt="Maximum"
							/>
						</Grid>
						<Grid item xs={2} sm={2}>
							<img
								src="https://sanalpos.isbank.com.tr/fim/est3dimages/isbank/maestro.gif"
								width="100"
								height="55"
								alt="Maestro"
							/>
						</Grid>
						<Grid item xs={1} sm={1}></Grid>
					</Grid>
				</Grid>
			</Grid>
			<input type="hidden" name="clientid" value="" />
			<input type="hidden" name="oid" value="" />
			<input type="hidden" name="amount" value="" />
			<input type="hidden" name="okurl" value="" />
			<input type="hidden" name="failUrl" value="" />
			<input type="hidden" name="storetype" value="" />
			<input type="hidden" name="rnd" value="" />
			<input type="hidden" name="hash" value="" />
			<input type="hidden" name="currency" value="" />
			<input type="hidden" name="lang" value="" />
			<input type="hidden" name="TranType" value="" />
			<input type="hidden" name="hashAlgorithm" value="" />
			<input type="hidden" name="encoding" value="UTF-8" />
		</form>
	);
};

export default PaymentStep;
